// React
import React from "react";
import PropTypes from "prop-types";
// i18next
import { withNamespaces } from "react-i18next";
// Styles
import styles from "./TransactionAmountLabel.css";

const TransactionStates = {
  NotSet: -1,
  Initialization: 0,
  PendingWaitingForNotification: 1,
  Cancelled: 2,
  Failed: 3,
  Success: 4,
  Deleted: 5,
  AuthorisationRefused: 6,
  Refunded: 7
};

const TransactionAmountLabel = ({ transactionState, totalAmountFormatted }) => {
  return (
    <span style={styles.transactionAmountBaseStyle} class={getTransactionAmountLabelClass(transactionState)}>
      {getTransactionAmountLabelFormat(transactionState, totalAmountFormatted)}
    </span>
  );
};

function getTransactionAmountLabelClass(transactionState) {
  switch (transactionState) {
    case TransactionStates.Success:
      return "text-danger";     // Paid: Red text, since it is a negative transaction from the candidates POV

    case TransactionStates.Refunded:
      return "text-success";    // Refund: Green text, since it is a positive transaction from the candidates POV

    case TransactionStates.Initialization:
    case TransactionStates.PendingWaitingForNotification:
    case TransactionStates.Cancelled:
    case TransactionStates.Failed:
    case TransactionStates.AuthorisationRefused:
    case TransactionStates.NotSet:
    case TransactionStates.Deleted:
    default:
      return "";                // Everything else: Default black text, since the transaction was not successful (yet) and no money has been transfered.
  }
}

function getTransactionAmountLabelFormat(transactionState, totalAmountFormatted) {
  switch (transactionState) {
    case TransactionStates.Success:
      return "- " + totalAmountFormatted;

    case TransactionStates.Refunded:
      return "+ " + totalAmountFormatted;

    case TransactionStates.Initialization:
    case TransactionStates.PendingWaitingForNotification:
    case TransactionStates.Cancelled:
    case TransactionStates.Failed:
    case TransactionStates.AuthorisationRefused:
    case TransactionStates.NotSet:
    case TransactionStates.Deleted:
    default:
      return totalAmountFormatted;
  }
}



TransactionAmountLabel.propTypes = {
  transactionState: PropTypes.number.isRequired,
  totalAmountFormatted: PropTypes.string.isRequired
};

export default withNamespaces()(TransactionAmountLabel);
